import React from "react";
import Articles from "../pages/articles/Articles";
import ArticleDetails from "../pages/articles/ArticleDetails";
import EditArticle from "../pages/articles/EditArticle";
import CreateArticle from "../pages/articles/CreateArticle";

export const articleRoutes = [
  { path: "/articles", element: <Articles /> },
  { path: "/articles/:articleId", element: <ArticleDetails /> },
  { path: "/articles/:articleId/edit", element: <EditArticle /> },
  { path: "/articles/create", element: <CreateArticle /> },
];
